export default __webpack_public_path__ + "static/media/UK01.f9942915.mp3";